<script setup lang="ts">

const btnText = ref('Copy')
const copyText = () => {
    const el = document.getElementById('text-to-copy') as HTMLElement
    navigator.clipboard.writeText(el.innerText);
    btnText.value = 'Copied!'
    _Delay(() => {
        btnText.value = 'Copy'
    }, 1000)
}
</script>
<template>
    <div class="copy-to-clipboard">
        <div id="text-to-copy">
            <slot />
        </div>
        <button @click="copyText()">{{ btnText }}</button>
    </div>
</template>

<style>
.copy-to-clipboard #text-to-copy {
    border: 1px #000 solid;
    border-radius: .5rem;
    padding: 1rem;
    width: fit-content;
    margin-bottom: 1rem;
}
</style>